$(function () {
    const $placementModal = $('#yr5-placement-add-edit-modal');
    const $deleteModal    = $('#yr5-placement-delete-modal');
    const $locationSelect = $('#location-id');
    const $locationClone  = $locationSelect.clone();
    const $form           = $('#yr5-placement-add-edit-form');
    const $deleteForm     = $('#yr5-placement-delete-form');

    // Edit Placement Modal
    $('.yr5-placement-add-edit-btn').on('click', function (e) {
        e.preventDefault();

        const placement = getPlacement(this);

        $placementModal.modal('show');
        $('.feedback-form-container').show();

        resetLocationDropdown(placement.ptype);

        $('#placement-type').val(placement.ptype);
        $('.block-number').html(placement.block);
        $('input[name="block"]').val(placement.block);
        $('input[name="placement-id"]').val(placement.placement_id);

        $locationSelect.val(placement.location_id).trigger('change');

        checkFeedbackFormParticipants(placement);
    });

    // New Placement Modal
    $('.new-placement').on('click', function (e) {
        e.preventDefault();

        const block = $(this).closest('.placement-row').data('block');

        $placementModal.modal('show');

        $form.trigger('reset');
        $locationSelect.val('').trigger('change');

        $('.block-number').html(block);
        $('input[name="block"]').val(block);

        hideLocationDropdown();

        $('.feedback-form-container').hide();
        $('.feedback-form-notice').hide();
        $('.feedback-form-clash').empty();
    });

    // Delete Placement Modal
    $('.yr5-placement-delete-btn').on('click', function (e) {
        e.preventDefault();

        const placement = getPlacement(this);
        const location  = [placement.name, placement.town].filter(Boolean).join(', ') || 'N/A';

        $('.feedback-form-container').show();
        $('.placement-location').text(location);
        $('.placement-type').text(placement.ptype || 'N/A');

        $deleteForm.find('input[name="placement-id"]').val(placement.placement_id);
        $deleteForm.find('input[name="email"]').val(placement.email);
        $deleteForm.find('input[name="academic-year"]').val(academicYear);
        $deleteForm.find('input[name="block"]').val(placement.block);
        $('.block-number').html(placement.block);

        $deleteModal.modal('show');

        checkFeedbackFormParticipants(placement);
    });

    // Get a placement from the row data
    function getPlacement(element) {
        return $(element).closest('.placement-row').data('placement');
    }

    // Check for feedback form participation
    function checkFeedbackFormParticipants(placement) {
        $.ajax({
            type: 'GET',
            url: 'yr5/ajax_checkFeedbackFormParticipants',
            data: {
                email: placement.email,
                academicYear: academicYear,
                block: placement.block,
            },
            dataType: 'json',
            beforeSend: function () {
                $('.feedback-form-notice').hide();
                $('.feedback-form-clash').html(
                    '<i class="icon icon-spinner icon-spin"></i> Checking Course Feedback system...'
                );

                $deleteForm.find('.btn').prop('disabled', true);
                $form.find('.btn').prop('disabled', true);
            },
            success: function (data) {
                const $feedbackFormClash = $('.feedback-form-clash');

                $feedbackFormClash.empty();

                if (data.length) {
                    $feedbackFormClash.removeClass('alert-info').addClass('alert-danger');
                    $('.feedback-form-container').show();
                    $('.feedback-form-notice').show();

                    $.each(data, function (index, element) {
                        const completed = parseInt(element.completed) === 1
                            ? 'Completed (Will NOT be deleted)'
                            : 'Not yet completed (Will be deleted)';

                        $('<div>')
                            .text(
                                `(ID: ${element.id}) ${element.name}, ${element.location} - ${completed}`
                            )
                            .appendTo($feedbackFormClash);
                    });
                } else {
                    $feedbackFormClash.removeClass('alert-danger').addClass('alert-info');
                    $('<div>')
                        .text('No active Course Feedback Forms associated with this student. OK to proceed')
                        .appendTo($feedbackFormClash);
                }
            },

            complete: function () {
                $deleteForm.find('.btn').prop('disabled', false);
                $form.find('.btn').prop('disabled', false);
            },
        });
    }

    function hideLocationDropdown() {
        $('label[for="location-id"]').hide();
        $locationSelect.hide();
        $locationSelect.next().hide();
    }

    function showLocationDropdown() {
        $('label[for="location-id"]').show();
        $locationSelect.show();
        $locationSelect.next().show();
    }

    // Reset location drop-down based on selected placement type
    function resetLocationDropdown(placementType) {
        const typeSelection = placementType || $('#placement-type').val();

        $locationSelect.empty();

        if (typeSelection === '' || typeSelection === 'ELECT') {
            hideLocationDropdown();
        } else {
            $locationClone
                .find(`option#placeholder, option.${typeSelection}`)
                .clone()
                .appendTo($locationSelect);

            showLocationDropdown();
        }
    }

    $('#placement-type').on('change', function () {
        resetLocationDropdown();
    });

    $form.validate({
        ignore: ':hidden, [contenteditable="true"]:not([name])',
        rules: {
            block: 'required',
            'placement-type': 'required',
            'location-id': 'required',
            'user-id': 'required',
        },
        messages: {
            block: 'Please select a block',
            'placement-type': 'Please select a type',
            'location-id': 'Please select a placement',
            'user-id': 'Please select a student',
        },
        errorPlacement: function (error, element) {
            if (element.hasClass('select2') && element.next('.select2-container').length) {
                error.insertAfter(element.next('.select2-container'));
            } else {
                error.insertAfter(element);
            }
        },
    });
});
